// extracted by mini-css-extract-plugin
export default {"titleRow":"lNDMJvuA9yWOAO5PYwUl","title":"wQVsBRoMXP92zl9IEM3A","controlBlock":"Hmi_1hubANxvWSBcwga4"};